// import { config } from "process";
const logo = "assets/qwizard.png";
const menuLogo = "assets/qwizard.png";
const icon = "assets/icon/qwizard-icon.png";

let chromecastAppId;
//applicationID = "F5AEBEA2"; // prod
//applicationID = "C76CC454"; // homeqwiz prod
//chromecastAppId = "6405A5D3"; // dave test
//chromecastAppId = "6C3F2642"; // cast2 prod
chromecastAppId = "6A6CCF49"; // BV2 prod

const devConstants = {
  ROUND_1_CW_TIME: 25000 * 2,
  INTRO_SLIDE_TIME: 20000,
  INTRO_AD_TIME: 10000,
  END_ROUND_SLIDE_TIME: 25000,
  END_ROUND_AD_TIME: 15000,
};

const prodConstants = {
  ROUND_1_CW_TIME: 25000 * 2,
  INTRO_SLIDE_TIME: 20000,
  INTRO_AD_TIME: 10000,
  END_ROUND_SLIDE_TIME: 25000,
  END_ROUND_AD_TIME: 15000,
};

const dev = {
  OUTPUT_URL: "http://localhost:5173/",
  // OUTPUT_URL: "https://output.qwizard.net/",
  // API_URL: "https://triviaozapi.qwizard.net/api/",
  API_URL: "https://api.qwizard.net/api/",
  //API_URL: "http://localhost:8081/api/",
  //API_URL: "https://qwizardapi.ngrok.app/api/",
  WEBSOCKET_URL: "https://ws.qwizard.net/",
  // WEBSOCKET_URL: "http://localhost:3001",
  //WEBSOCKET_URL:
  //  "https://be6a-2001-4455-6c0-a400-c138-4db-c237-c032.ngrok-free.app",

  MEDIA_HOST: "https://media.qwizard.net/",
  TEST_MODE: true,
};

const prod = {
  OUTPUT_URL: "https://output.qwizard.net/",
  API_URL: "https://api.qwizard.net/api/",
  // API_URL: "https://triviaozapi.qwizard.net/api/",
  MEDIA_HOST: "https://media.qwizard.net/",
  WEBSOCKET_URL: "https://ws.qwizard.net/",
  TEST_MODE: false,
};

const services = process.env.NODE_ENV === "production" ? prod : dev;
// const services = dev;
const constants =
  process.env.NODE_ENV === "production"
    ? { ...devConstants, ...prodConstants }
    : devConstants;

if (process.env.NODE_ENV === "production") {
  console.log("prod");
} else {
  console.log("dev");
}
console.log("services", services);

const token =
  "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJhZG1pbiI6dHJ1ZX0.pTd5Vx8DO2puKtB3JvLj6s_jjzDpdTnCzDRTj2h8W9Y";

const config = {
  LOGO: logo,
  MENU_LOGO: menuLogo,
  ICON: icon,
  ...services,
  ...constants,
  CONSTANTS: constants,
  TOKEN: token,
  CC_APP_ID: chromecastAppId,
};

export default config;
